import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { UserTitle } from "@main/users";
import { EpisodeService } from "@project/episode/episode.service";

@Component({
    selector: "m-user-initials",
    template: `
        <div class="user-initials">
            <div class="user-initials-circle" [class]="circleStyleClass">
                {{ userInitials }}
            </div>

            <div class="user-initials-info"  [class.justify-content-center]="!header" >
                 <p *ngIf="header">{{ header }}</p>
                <p>{{ userInfo }}</p>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ["./user-initials.component.scss"]
})
export class UserInitialsComponent implements OnChanges {
    userInitials: string;
    userInfo: string;

    @Input() header: string;
    @Input() title?: UserTitle;
    @Input() unknownFullNameLabel = "Unknown";

    private _fullName: string;
    @Input() set fullName(value: string) {
        this._fullName = value ?? this.unknownFullNameLabel;
    }
    get fullName() {
        return this._fullName;
    }

    @Input() role: string;
    @Input() circleStyleClass: "created-by" | "updated-by" = "created-by";

    constructor(private episodeService: EpisodeService) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.setupInfo();
    }

    private setupInfo() {
        this.userInitials = this.fullName?.replace(/^([a-z])([^\s]*\s*)([a-z])(.*)$/i, "$1$3").toUpperCase();
        this.userInfo = this.createUserInfo();
    }

    private createUserInfo() {
        const role = this.episodeService.getRole(this.role);
        const roleName = !this.role || role === this.role ? "" : `(${role})`;
        return `${this.episodeService.getTitle(this.title)} ${this.fullName} ${roleName}`;
    }
}
